export default __webpack_public_path__ + "static/media/logoLight.c5510384.svg";